export enum CommunicationParty {
  customer,
  merchant,
  platform,
}

export enum MessageType {
  Text,
  Photo,
}

export interface IPushDto {
  orderId: string | null
  merchId: string
}

export interface GetCurrentConversationsRequest {
  pageIndex: number
  pageSize: number
  requestFrom: CommunicationParty
  keyword?: string
  isExactSearch: boolean
  ts: number
  merchIds: string[]
}

export interface GetCurrentConversationsResponse {
  result: ConversationDto[]
}

export interface ConversationDto {
  id: string
  contactsId: string
  merchId: string
  userId: string
  contactsName: string
  orderId: string | null
  head: string
  lastMessage: MessageDto
  unReadCount: number
  communicationToParty: CommunicationParty
  conversationTotal: number
  userOrderScores: UserOrderScores
  labels: IMLabel[]
}

export interface MessageDto extends IPushDto {
  id: string
  sendByParty: CommunicationParty
  sendToParty: CommunicationParty
  nameOfSendTo: string
  nameOfSendBy: string
  type: MessageType
  content: string | null
  attachmentId: string
  orderId: string | null
  merchId: string
  sendToUserId: string | null
  sendToHeadPicture: string
  sendByUserId: string
  sendByHeadPicture: string
  isReaded: boolean
  sendTime: Date | string
  orderSerialNumber: string
}

export interface GetCurrentMessagesRequest {
  communicationTo: string
  communicationToParty: CommunicationParty
  requestFrom: CommunicationParty
  pageIndex: number
  pageSize: number
  orderId: string | null
}

export interface GetNewMessagesRequest {
  communicationTo: string
  communicationToParty: CommunicationParty
  requestFrom: CommunicationParty
  lastRequestedTime: Date | string
  orderId: string | null
}

export interface GetCurrentMessagesResponse {
  result: MessageDto[]
}

export interface GetNewMessagesResponse {
  result: MessageDto[]
}

export interface SendMessageToCustomerCommand extends SendMessageDetails {
  sendToUserId: string
}

export interface SendMessageDetails {
  messageId: string
  attachmentId: string | null
  content: string | null
  type: MessageType
  orderId: string | null
  commandFrom: CommunicationParty
}

export interface DeleteConversationCommand {
  merchId: string | null
  targetUserId: string | null
  commandFrom: CommunicationParty
}

export interface GetTotalUnReadCountRequest {
  merchIds: string[]
  orderIds: string[]
  userIds: string[]
  requestFrom: CommunicationParty
}

export interface GetTotalUnReadCountResponse {
  count: number
}

export interface UpdateReadStatusCommand {
  orderId: string | null
  merchId: string | null
  userId: string | null
  commandFrom: CommunicationParty
}

export interface TrackableMessageDto extends MessageDto {
  isLoading: boolean
  hasError: boolean
}

export interface UserOrderScores {
  positiveOrderForShop: number
  negativeOrderForShop: number
  positiveOrderForPlatform: number
  negativeOrderForPlatform: number
}

export interface IMLabel {
  id: string
  userId: string
  merchId: string
  label: string
}
